
import { createApp } from 'vue'
import App from './App.vue'

import router from './routeur.js'
import store from './store.js'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

import vDateFr from './directives/vDateFr.js'


const vuetify = createVuetify({
    components,
    directives
})

const app = createApp(App);
window.app = app;
window.router = router;
window.store = store;

// Directive globale de saisie de date FR (010181 -> 01/01/1981), utilisable partout via v-date-fr.
app.directive('date-fr', vDateFr);

//Use vuetify
app.use(vuetify);

app.use(router);
app.use(store);
app.mount('#app');




//createApp(App).use(router)
//              .use(store)
//              .mount('#app')


